<template>
  <v-layout column align-start justify-start d-flex fluid fill-height>
    <v-progress-linear class='ma-0' :color='$store.getters.uiAccent' height='1' :active='reportIndices.render' :indeterminate='true'></v-progress-linear>
  	<v-container class="text-xs-right" fluid align-content-space-between d-flex pa-0 style = 'height: 100%;'>
  		<v-layout align-start justify-start pl-sm-4 pl-0 pt-sm-1 pt-0 pa-0>
        <v-container d-flex pa-0 fluid fill-height id='embedContainer'>
        </v-container>
        <v-btn
            color="red darken-2"
            fab
            dark
            id="errorButton"
            class="hidden-xs-only"
            @click="dialogs.reportError = true"
        >
          <v-icon>
            mdi-alert
          </v-icon>
        </v-btn>
        <v-layout class="hidden-xs-only" style='text-align: left; flex-direction: column-reverse !important;' column wrap align-end justify-center px-4>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn v-on = 'on' small icon depressed :disabled = 'reportIndices.load' @click = 'dialogs.reportSchedule = true;'><v-icon small>mdi-history</v-icon></v-btn>
            </template>
            <span>График обновлений</span>
          </v-tooltip>
          <schedule-report-controller 
            :report = 'currentReport' 
            :meta = 'reportMeta' 
            :initialState.sync = 'dialogs.reportSchedule'
          ></schedule-report-controller>
          <report-error
              :initialState.sync = 'dialogs.reportError'
          ></report-error>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed v-if = '!controls.bookmarks' :disabled = 'reportIndices.load' @click = 'toggleReportBookmarks'><v-icon small>mdi-bookmark-outline</v-icon></v-btn>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed v-if = 'controls.bookmarks' :disabled = 'reportIndices.load' @click = 'toggleReportBookmarks'><v-icon small>mdi-bookmark</v-icon></v-btn>
            </template>
           <span>Панель закладок</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed :disabled='reportIndices.load || currentReport.mode_edit == "R"'  @click = 'toggleReportMode()'><v-icon small>{{reportMeta.mode != "view"? "mdi-eye-outline": "mdi-square-edit-outline"}}</v-icon></v-btn>
            </template>
            <span>{{reportMeta.mode != "view" ? "Режим просмотра": "Режим редактирования"}}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed :disabled = 'reportIndices.load || controls.reportUpdateBlocked || currentReport.mode_edit == "R"' @click = 'refreshReportDataset()'><v-icon small>mdi-refresh</v-icon></v-btn>
            </template>
            <span>Обновить данные</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small :disabled = 'currentReport.mode_persons == "R"' v-on = 'on' class = 'pa-0 ma-0' icon depressed @click.stop="dialogs.usersList = true;"><v-icon small>mdi-account-outline</v-icon></v-btn>
            </template>
            <span>Пользователи отчета</span>
          </v-tooltip>
          <users-report-controller :report = 'currentReport' :initialState.sync = 'dialogs.usersList'></users-report-controller>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed :disabled = 'reportIndices.load' @click = 'printReport()'><v-icon small>mdi-cloud-print-outline</v-icon></v-btn>
            </template>
            <span>Печатать</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator = '{ on }'>
              <v-btn small v-on = 'on' class = 'pa-0 ma-0' icon depressed :disabled = 'reportIndices.load' @click = 'expandReport()'><v-icon>mdi-fullscreen</v-icon></v-btn>
            </template>
            <span>Развернуть</span>
          </v-tooltip>
        </v-layout>
      </v-layout>
  		<v-snackbar
	  		v-model = 'dialogs.reportUpdate'
	  		color='grey darken-2'
	  		top multi-line
	  		:timeout='10000'
	  	>
	  		<span>Обновление успешно запущено. Пожалуйста, обновите страницу отчета через 5-10 минут.</span>
	  		<v-btn outlined small @click = 'dialogs.reportUpdate=false;'>ОК</v-btn>
	  	</v-snackbar>
  	</v-container>
  </v-layout>
</template>

<style>
	#embedContainer iframe {
		border: none !important;
		width: 100% !important;
	}
    #errorButton {
      position: absolute;
      bottom: 40px;
      right: 70px;
    }
    @media (max-width: 600px) {
      #embedContainer {
        padding: 0 !important;
        margin-left: -7px !important;
        width: calc(100% + 7px) !important;
      }
      #embedContainer iframe,
      #embedContainer *,
      .visualContainerHost,
      .visualContainerOutOfFocus {
        padding-left: 0 !important;
        margin-left: 0 !important;
      }
    }
</style>

<script>

  import UsersReportController from '@/components/entities/reports/Users.vue'
  import ReportScheduleController from '@/components/entities/reports/Schedule.vue'
  import ErrorReportController from '@/components/entities/errors/CreateDialog.vue'

  import Vue from 'vue'
  import mixin_pbi from '@/mixins/pbi'
  import * as pbi from 'powerbi-client'
  import dayjs from 'dayjs'
  import 'dayjs/locale/ru'

  dayjs.locale('ru')

  export default {
    components: {
      'users-report-controller': UsersReportController,
      'schedule-report-controller': ReportScheduleController,
      'report-error': ErrorReportController
    },
    mixins: [mixin_pbi],
    data() {
      return {
        dialogs: {
          reportUpdate: false,
          reportSchedule: false,
          usersList: false,
          notes: false,
          reportError: false,
        },
        controls: {
          reportUpdateBlocked: false,
          grantsLoading: false,
          bookmarks: false
        },
        reportMeta: {
          grants: {},
          info: {},
          pages: [],
          filtersApplied: [],
          filtersDefault: {
            tax: {},
            fee: {}
          },
          mode: 'view',
          updates: [],
          lastUpdate: ''
        }
      }
    },
    methods: {
      accessReport() {
        this.controls.grantsLoading = true;
        this.reportMeta = {
          mode: 'view'
        }
        this.$store.commit('setBreadcrumbs', [
          {text: 'Главная', disabled: false, to: '/', ripple: true}, 
          {text: this.currentReport.project_name, disabled: this.currentReport.mode_persons == "0", to: '/p/' + this.currentReport.project_id, ripple: true}, 
          {text: this.currentReport.name, disabled: true, to: '/r/' + this.currentReport.report_id, ripple: true}
        ]);
        if (!this.reportMeta.hasOwnProperty('grants') || !Object.keys(this.reportMeta.grants).length) {
          const obj = {
            emulateJSON: true,
            params: {'login': this.$store.getters.userLogin, 'type': 'access', 'role': this.currentReport.role_name},
            headers: this.$store.state.restrictedHeaders
          }
          // console.log('>>>',obj)
          // console.log('>>>',this.$store.getters.endpoint )
          this.$http.get(
            this.$store.getters.endpoint + '/db/grants', obj
          ).then( (r) => {
            // console.log(r)
            this.controls.grantsLoading = false;
            let response = r.body
            if (response.result) {
              this.reportMeta.grants = response.grants.data
              this.embedConfig['accessToken'] = this.reportMeta.grants.access_token
              this.renderReport(this.$vuetify.breakpoint.name == 'xs', document.querySelector('#embedContainer'), this.currentReport)
            } else {
              console.log('access declined: ', response)
            }
          }).catch( (e) => {

            let error = e.body
            console.log('error accessing grants: ', e)
          })
        } else {
          let start_time = new Date()
          let expiration_time = new Date(this.reportMeta.grants['expires_on'] * 1000)
          if (start_time > expiration_time) {
            this.$http.get(
              this.$store.getters.endpoint + '/db/grants', {
                emulateJSON: true,
                params: {'login': this.$store.getters.userLogin, 'type': 'refresh', 'refresh': this.reportMeta.grants.refresh_token},
                headers: this.$store.state.restrictedHeaders
              }
            ).then( (r) => {
              let response = r.body
              if (response.result) {
                this.reportMeta.grants = response.grants.data
                this.embedConfig['accessToken'] = this.reportMeta.grants.access_token
                this.renderReport(this.$vuetify.breakpoint.name == 'xs', document.querySelector('#embedContainer'), this.currentReport)
              } else {
                console.log('access declined: ', response)
              }
            }).catch( (e) => {
              let error = e.body
              console.log('error refreshing grants: '. error)
            })
          }
        }
      },
    	refreshReportDataset() {
        this.refreshReportDatasetPromise().then( (r) => {
          let response = r.body;
          this.dialogs.reportUpdate = true;
          this.reportUpdateBlocked = true;
          this.getReportRefreshHistory()
          this.$dataLayer.$emit('enrich', {
            event: 'interaction',
            data: {
              type: 'discover',
              target: 'report_emit_refresh'
            },
            once: false
          })
        });
    	},
  		toggleReportMode: function() {
  			if (this.currentReport.role_name != 'Клиент') {
  				this.toggleReportEdit()
  				this.$dataLayer.$emit('enrich', {
            event: 'interaction',
            data: {
              type: 'discover',
              target: 'report_toggle_mode'
            },
            once: false
          })
  		  }
		  }
    },
    computed: {
    	currentReport () {
    		return this.$store.state.currentReport
    	},
      reportUpdated() {
        return this.reportSuccessUpdate
      }
    },
    watch: {
    	'$route' (to,from) {
    		if (to.name == 'report' && Object.keys(to.params).length > 1) {
          this.$store.commit('cursorReport', to.params);
          let title_suffix = ''
          if (!to.params.is_client) {
            title_suffix += ' | 📎'
          } else {
            title_suffix += ' | '
          }
          title_suffix += to.params.name
          document.title = this.$store.getters.pageTitle + title_suffix
          this.$dataLayer.$emit('enrich', {
            event: 'navigation',
            data: {
              title: document.title,
              path: to.fullPath
            },
            once: false
          })
        }
    	},
      currentReport(value) {
        if (Object.keys(value).length > 0) {
          let title_suffix = ''
          if (!this.currentReport.is_client) {
            title_suffix += ' | ⓘ '
          } else {
            title_suffix += ' | '
          }
          title_suffix += this.currentReport.name
          document.title = this.$store.getters.pageTitle + title_suffix
          this.$dataLayer.$emit('enrich', {
            event: 'navigation',
            data: {
              title: document.title,
              path: document.location.pathname
            },
            once: false
          })
          this.accessReport();
        } else {
          this.$router.push({'path': '/'});
        }
      },
      reportUpdated(value) {
        if (this.reportUpdated) {
          this.controls.reportUpdateBlocked = dayjs(this.reportSuccessUpdate).add(1,'hour') >= dayjs()
          this.$store.commit(
            'updateHeaderSecondary', 
            `<span class = 'body-2 font-weight-light'>Обновлено: </span><span class = 'font-weight-regular'>${dayjs(this.reportSuccessUpdate).format('D MMM YYYY, H:mm:ss')}<span>`
          )
        } else {
          this.$store.commit(
            'updateHeaderSecondary', 
            `<span class = 'body-2 font-weight-light'>Не обновляется</span>`
          )
        }
      }
    },
    beforeRouteEnter (to, from, next) {
    	next(vm => {
        vm.dialogs.usersList = false;
        if (from.name || Object.keys(to.params).includes('report_id')) {
          vm.$store.commit('cursorReport', {});
          let reports = vm.$store.getters.userReports.filter( (p) => p.report_id == to.params.report_id);
          if (reports.length > 0) {
            vm.$store.commit('cursorReport', reports[0]);
          }
        };
      });
    },
    mounted() {
      this.reportMeta.filtersDefault.tax = new pbi.models.BasicFilter({
          table: "the_tax_modifier",
          column: "Режим вывода"
        }, "In", ['без НДС']);
    }
  };
</script>
